export const automaticResponseZh = {
  wantToConsult: '【智能监考员】请问你想咨询哪方面的问题？',
  followingQuestions1: '【智能监考员】你可能想了解以下关于“',
  followingQuestions2: '”的问题：',
  cannotBeResolved: '若无法解决，请向监考员描述你的问题',
  Unsolved: '未解决',
  Solved: '已解决',
  automaticName: 'autoDescCn'
}

export const automaticResponseEn = {
  wantToConsult: '[AI invigilator] What kind of questions do you want to consult?',
  followingQuestions1: '[AI invigilator] You may want to know the following questions about "',
  followingQuestions2: '" :',
  cannotBeResolved: 'If it cannot be solved, please describe your problem to the invigilator',
  Unsolved: 'Unsolved',
  Solved: 'Solved',
  automaticName: 'autoDescEn'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/automaticResponse.js